import { dateRenderer, dateSorter, getProp } from '@lib/generic.utils'
import NestedFileDownloadLink from '@components/ag-grid-helpers/NestedFileDownloadLink'
import { agPriceCol } from '@/ag-grid/ag-columns'

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'PO reference',
            field: 'member_purchase_order_reference',
            cellRenderer: params => getProp(params, 'value', 'N/A'),
            tooltipValueGetter: params => getProp(params, 'value', 'N/A')
          },
          {
            headerName: 'Date',
            field: 'order_item',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(getProp(params.value, 'order.date', null)),
            tooltipValueGetter: params => dateRenderer(getProp(params.value, 'order.date', null))
          },
          {
            headerName: 'Vendor',
            field: 'order_item',
            cellRenderer: params => getProp(params.value, 'order.provider.name'),
            tooltipValueGetter: params => getProp(params.value, 'order.provider.name')
          },

          agPriceCol('Amount', 'order_item.price'),

          {
            headerName: 'File',
            field: 'order_item.order.file',
            cellRendererFramework: NestedFileDownloadLink,
            tooltipValueGetter: params => getProp(params.value, 'name')
          },
          {
            headerName: 'Email',
            field: 'params.data.order_item.order.email_batch.id',
            cellRendererParams: params => ({
              onClick: () => this.openModal(params.data.order_item.order.email_batch?.id),
              value: params.data.order_item.order.email_batch ? 'see email' : null
            }),
            cellRendererFramework: 'LinkRenderer'
          }
        ],
        defaultColDef: {
          resizable: false,
          floatingFilter: false
        },
        domLayout: 'autoHeight'
      }
    }
  }
}
